export enum Locale {
    de = 'de',
    en = 'en'
}

export const LocaleToLanguage = new Map([
    ['de', 'deutsch'],
    ['en', 'englisch']
]);

export const DEFAULT_LOCALE = Locale.de;
